import React, { Component } from 'react'
import AnimNumCP from './AnimNum_CP'
import './AnimNum_style.css'

class InventoryCP extends Component {
  constructor(props) {
    super(props)
    this.state = {
      n:props.n,
    }
  }

  render() {
    let diffColorClass = 'invDifNone'
    let prefix = ''
    if (this.state.n < 0) {
      prefix = ''
      diffColorClass = 'invDiffNeg'
    }
    if (this.state.n > 0) {
      prefix = '+'
      diffColorClass = 'invDiffPos'
    }
    
    return (
      <div className={'TOC_info_line '+diffColorClass}>
        {prefix}<AnimNumCP n={this.state.n} />{this.props.children}
      </div>
    )
  }

  componentDidUpdate() {
    if (undefined !== this.props?.n) this.update(this.props.n)
  }

  update(n) {
    if (undefined !== this.state?.n && this.state.n !== n) {
      this.setState({
        n: n,
      })
    }
  }
  
}

export default InventoryCP
